import Index from "../index";
import request from "@/common/request";
import { IGetSpecialDetail, IGetInfoThemeList, IVideoDetail } from "./types.d";
import { IResponse } from "../types";
class IndexRequest extends Index {
  /**
   * 专题详情
   * @param infoClassifyId 专题id
   */
  specialDetail(infoClassifyId: string): Promise<IGetSpecialDetail> {
    return request.post("/specialDetail.html", {
      infoClassifyId: infoClassifyId
    });
  }

  /**
   * 分类列表
   * @param lastId 最后一个id
   * @param infoThemeId 分类id
   * @param sortNoValue 排序号
   * @param onlineTimeValue 上线时间
   */
  infoThemeList(
    infoClassifyId: string,
    infoThemeId: string,
    // limit: number,
    // page: number,
    appId: string,
    lastId?: string,
    sortNoValue?: string,
    onlineTimeValue?: string
  ): Promise<IGetInfoThemeList> {
    return request.post(
      process.env.VUE_APP_BASEGATE_API + "/info/getSpecialSubList",
      {
        infoClassifyId,
        themeId: infoThemeId,
        appId: appId,
        lastId,
        lastSortNo: sortNoValue,
        lastOnlineTime: onlineTimeValue
      }
    );
  }
  //视频详情
  /**
   * @param infoClassifyId 新闻id
   */
  getActNewsInfo(infoClassifyId: string): Promise<IVideoDetail> {
    return request.post("/info/getActNewsInfo.html", {
      infoClassifyId
    });
  }
  /**
   * 图文详情
   * @param infoClassifyId 新闻id
   */
  async getInfoDetailNew(infoClassifyId: string): Promise<IVideoDetail | any> {
    // return request.post("/infoDetailNew.html", {
    //   infoClassifyId
    // });
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/infoDetailNew/${infoClassifyId}.json`
      );
      res = {
        code: 0,
        data: res1
      };
    } catch (error) {
      res = await request.post("/infoDetailNew.html", {
        infoClassifyId
      });
    }
    return res;
  }

  /**
   * 万州图文详情接口、先写死直接请求接口
   * @param infoClassifyId 新闻id
   */
  async wzGetInfoDetailNew(
    infoClassifyId: string
  ): Promise<IVideoDetail | any> {
    let res;
    res = await request.post("/infoDetailNew.html", {
      infoClassifyId
    });
    return res;
  }

  /**
   * 平湖号详情
   * @param params
   * @param infoClassifyId 新闻id
   */
  phhNewsDetail(infoClassifyId: string): Promise<any> {
    return request.post("/wan/phhNews/details.html", {
      infoClassifyId
    });
  }
  /**
   * 教育号详情
   * @param params
   * @param infoClassifyId 新闻id
   */
  jyhNewsDetail(infoClassifyId: string): Promise<any> {
    return request.post("/wan/jyhNews/details.html", {
      infoClassifyId
    });
  }

  /**
   * 获取用户积分
   * @param params
   * @returns
   */
  queryRemainderPoint(params: {
    appId: string | number;
    token: string;
  }): Promise<any> {
    return request.post("/wan/phhNews/queryRemainderPoint.html", {
      appId: params.appId,
      token: params.token
    });
  }

  /**
   * 教育号获取用户积分
   * @param params
   * @returns
   */
  jyhQueryRemainderPoint(params: {
    appId: string | number;
    token: string;
  }): Promise<any> {
    return request.post("/wan/jyhNews/queryRemainderPoint.html", {
      appId: params.appId,
      token: params.token
    });
  }

  /**
   * 平湖号打赏
   * @param params
   * @returns
   */
  reward(params: {
    appId: string | number;
    token: string;
    infoClassifyId: string;
    integral: string | number;
    phhId: string;
  }): Promise<any> {
    return request.post("/wan/phhNews/reward.html", {
      ...params
    });
  }
  /**
   * 教育号打赏
   * @param params
   * @returns
   */
  jyhReward(params: {
    appId: string | number;
    token: string;
    infoClassifyId: string;
    integral: string | number;
    jyhId: string;
  }): Promise<any> {
    return request.post("/wan/jyhNews/reward.html", {
      ...params
    });
  }

  /**
   * 海报分享
   * @param infoClassifyId  新闻id
   * @returns
   */
  getPosterShareData(params: { infoClassifyId: string }): Promise<any> {
    return request.post("getPosterShareData.html", {
      infoClassifyId: params.infoClassifyId
    });
  }
}

export default IndexRequest;
